﻿import {translation} from "@2d-front-monorepo/core";
import {showErrorDialog, toggleLoadingDialog} from "@2d-front-monorepo/design-library";
import {PaymentStatus, PermitResult, PermitStatusType} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX, useCallback} from "react";
import {useNavigate} from "react-router";
import {getHttpClient} from "../../../hooks/getHttpClient";
import {ReloadEntities, reloadPermits} from "../../../hooks/reloadPermits";
import {PrivateRoutes} from "../../../routes";

export type BillComponentProps = {
	permit: PermitResult;
}

export function BillComponent(props: BillComponentProps): JSX.Element | undefined {
	const {permit} = props;
	const paymentStatus = permit.payment?.status ?? PaymentStatus.Void;
	const paymentEnabled = permit.status.type === PermitStatusType.Approved && (paymentStatus === PaymentStatus.ReadyToPay || paymentStatus === PaymentStatus.Rejected);
	const navigate = useNavigate();

	const onSubmit = useCallback(async function (): Promise<void> {
		toggleLoadingDialog(true);
		try {
			await getHttpClient().permits.bill(permit.id);

		} catch (e) {
			// Stay on the permit so the user can retry; navigating away made the failed
			// payment look successful behind the error dialog.
			showErrorDialog(e);
			return;

		} finally {
			toggleLoadingDialog(false);
		}

		await reloadPermits(ReloadEntities.Permits);
		navigate(PrivateRoutes.permitsList);
	}, [permit.id, navigate]);

	if (!paymentEnabled) {
		return undefined;
	}

	return (
		<div className={"padded inline"}>
			<p className={"layout horizontal aligned middle form-message form-message--warning"}>
				<span className={"flex"}>{translation(paymentStatus === PaymentStatus.ReadyToPay
					? PermitTranslations.permit_page__bill__title_to_pay
					: PermitTranslations.permit_page__bill__title_error, {error: translation(permit.payment?.paymentError ?? "")})}</span>

				<button className="form__button form__button--primary form__button--small" onClick={onSubmit}>
					{translation(PermitTranslations.permit_page__bill__button)}
				</button>
			</p>
		</div>
	);
}
